import { useState, useEffect } from "react";
import { Menu, X, MessageCircle } from "lucide-react";

const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "Sobre mí", href: "#sobre-mi" },
  { label: "Cómo trabajamos", href: "#como-trabajamos" },
  { label: "Preguntas", href: "#faq" },
  { label: "Contacto", href: "#contacto" },
];

const WA_LINK = "https://wa.me/5491165162564?text=Hola%2C%20quiero%20hacer%20una%20consulta%20contable.";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled
          ? "backdrop-blur-md bg-cream-300/85 border-b border-navy-900/5 shadow-sm"
          : "bg-transparent"
        }`}
    >
      <nav className="container mx-auto px-4 md:px-6 max-w-7xl flex items-center justify-between h-16 md:h-20">
        <a
          href="#inicio"
          onClick={(e) => handleNavClick(e, "#inicio")}
          data-testid="header-logo"
          className={`font-poppins font-semibold text-lg md:text-xl tracking-tight transition-colors duration-300 ${scrolled ? "text-navy-900" : "text-white"
            }`}
        >
          Bárbara <span className="text-gold">Cargnello</span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`font-poppins text-sm font-medium hover:text-gold transition-colors duration-200 ${scrolled ? "text-navy-800" : "text-white/90"
                  }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-whatsapp-btn"
          className="hidden md:inline-flex items-center gap-2 bg-[#25D366] text-black rounded-full px-6 py-2.5 font-poppins text-sm font-medium hover:bg-[#20ba5a] transition-all duration-200 hover:scale-105 shadow-md"
        >
          <MessageCircle className="w-4 h-4" />
          Consultar por WhatsApp
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2"
          aria-label={mobileOpen ? "Cerrar menú" : "Abrir menú"}
        >
          {mobileOpen ? (
            <X className={`w-6 h-6 ${scrolled ? "text-navy-900" : "text-white"}`} />
          ) : (
            <Menu className={`w-6 h-6 ${scrolled ? "text-navy-900" : "text-white"}`} />
          )}
        </button>
      </nav>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-cream-300/95 backdrop-blur-lg border-t border-navy-900/5 animate-fade-in"
        >
          <ul className="container mx-auto px-4 py-4 space-y-1">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block py-3 px-4 rounded-lg font-poppins text-sm font-medium text-navy-800 hover:bg-cream-400/50 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-whatsapp-btn"
                className="flex items-center justify-center gap-2 bg-navy-900 text-cream-300 rounded-full px-6 py-3 font-poppins text-sm font-medium"
              >
                <MessageCircle className="w-4 h-4" />
                Consultar por WhatsApp
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

